<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VUMZc0/tc-custom/9781488082979.jpg?1699984645601" alt="This image is the cover for the book Before We Were Strangers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Before We Were Strangers
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i>–Bestselling Author: “I loved this twisty tale of friends, enemies, lovers, liars, and a family fractured by secrets.” —Susan Wiggs</b><br/><br/>Five-year-old Sloane McBride couldn’t sleep that night. Her parents were arguing again, their harsh words heating the cool autumn air. And then there was that other sound—the ominous thump before all went quiet.<br/><br/>In the morning, her mother was gone.<br/><br/>The official story was that she left. Her loving, devoted mother! That hadn’t sat any better at the time than it did when Sloane moved out at eighteen, anxious to leave her small Texas hometown in search of anywhere else. But not even a fresh start working as a model in New York could keep the nightmares at bay. Or her fears that the domineering father she grew up with wasn’t just difficult—he was deadly.<br/><br/>Now another traumatic loss forces Sloane to realize she owes it to her mother to find out the truth, even if it means returning to a town full of secrets and lies, a jilted ex-boyfriend, and a father and brother who’d rather see her silenced. But as Sloane starts digging into the past, the question isn’t whether she can uncover what really happened that night—it’s what will remain of her family if she does . . . <br/><br/>“A dark, twisty plot that will leave readers unsure until the very end keeps the pages turning in this engrossing, insightful romantic thriller.” —<i>Library Journal</i><br/><br/>“The kind of book best swallowed in one sitting: suspenseful, surprising, and 100% addictive.” —Kimberly Belle, <i>USA Today</i>–bestselling author of <i>The Marriage Lie</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Novak
      </h2>
      
      <p class="authorDescription body article">New York Times bestselling author Brenda Novak has written over 60 novels. An eight-time Rita nominee, she's won The National Reader's Choice, The Bookseller's Best and other awards. She runs Brenda Novak for the Cure, a charity that has raised more     than $2.5 million for diabetes research (her youngest son has this disease). She considers herself lucky to be a mother of five and married to the love of her life.&#160;<a href="http://www.brendanovak.com">www.brendanovak.com</a><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59a7e474